import { isPlatformBrowser } from '@angular/common';
import { afterNextRender, Component, inject, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { FooterDeferred } from '@app/components/footer/footer-deferred';
import { Navbar } from '@app/components/header/navbar/navbar';
import { ICON_MAP } from '@app/constants/icon.map';
import { RouteEnum } from '@app/constants/route.enum';
import { AppBootstrapService } from '@app/services/app-bootstrap/app-bootstrap.service';
import { Network } from '@app/services/network/network';
import { Utility } from '@app/services/utility/utility';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Navbar, FooterDeferred],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  protected readonly routeEnum = RouteEnum;
  private readonly router = inject(Router);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly utilityService = inject(Utility);
  private readonly appBootstrap = inject(AppBootstrapService);
  //Network service injection required to initialize the service at app component level
  private readonly _network = inject(Network);
  protected showLayout = signal(this.shouldShowLayout(this.router.url));

  constructor() {
    afterNextRender(() => {
      if (!isPlatformBrowser(this.platformId)) {
        return;
      }
      this.utilityService.registerIcons(ICON_MAP);
      queueMicrotask(() => {
        void this.appBootstrap.run();
      });
    });
  }

  ngOnInit(): void {
    this.showLayout.set(this.shouldShowLayout(this.router.url));
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (
          event.url === RouteEnum.LOADER ||
          event.url === RouteEnum.PRIVACY_POLICY_MOBILE ||
          event.url === RouteEnum.TERMS_AND_CONDITIONS_MOBILE ||
          event.url === RouteEnum.MAINTENANCE
        ) {
          this.showLayout.set(false);
        }
      }
      if (event instanceof NavigationEnd) {
        this.showLayout.set(this.shouldShowLayout(this.router.url));
      }
    });
  }

  private shouldShowLayout(url: string): boolean {
    return (
      url !== RouteEnum.LOADER &&
      url !== RouteEnum.PRIVACY_POLICY_MOBILE &&
      url !== RouteEnum.TERMS_AND_CONDITIONS_MOBILE &&
      url !== RouteEnum.MAINTENANCE
    );
  }
}
